"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Space = _interopRequireDefault(require("../Space"));
var _Label = _interopRequireDefault(require("../Label"));
const _excluded = ["space", "dataTestId"];
function SpacedLabel(_ref) {
  let {
      space,
      dataTestId
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Space.default, {
    bottom: true,
    size: space,
    dataTestId: dataTestId ? `${dataTestId}-container` : undefined
  }, /*#__PURE__*/_react.default.createElement(_Label.default, (0, _extends2.default)({
    color: _Label.default.COLOR.black
  }, props, {
    dataTestId: props.dataTestId || dataTestId
  })));
}
SpacedLabel.SPACE = _Space.default.SIZE;
SpacedLabel.COLOR = _Label.default.COLOR;
SpacedLabel.OVERFLOW = _Label.default.OVERFLOW;
SpacedLabel.defaultProps = {
  space: _Space.default.SIZE.xxsmall
};
var _default = exports.default = SpacedLabel;